/**
 * Include your custom JavaScript here.
 */

document.addEventListener("DOMContentLoaded", function () {
  // Button Popup
  (function buttonPopup() {
    var buttonPopup = document.getElementById('button_popup--cta');
    if (buttonPopup) {
      var modalPopup = document.querySelector('.modal--button_popup');
      var buttonPopupCta = buttonPopup.querySelector('.heading');
      var buttonPopupClose = buttonPopup.querySelector('.button_popup--cta__close');
      if (buttonPopupCta && modalPopup) {
        buttonPopupCta.addEventListener('click', function () {
          modalPopup.setAttribute('aria-hidden', 'false');
          buttonPopup.style.display = "none";
        });
      }
      if (buttonPopupClose) {
        buttonPopupClose.addEventListener('click', function () {
          buttonPopup.style.display = "none";
        });
      }
      if (modalPopup) {
        var modalPopupClose = modalPopup.querySelector('.popup-newsletter__close');
        if (modalPopupClose) {
          modalPopupClose.addEventListener('click', function () {
            modalPopup.setAttribute('aria-hidden', 'true');
          });
        }
      }
    }

    // Handle URL with customer_posted=true
    if (window.location.href.indexOf("customer_posted=true") > -1) {
      if (buttonPopup) {
        var modalPopup = document.querySelector('.modal--button_popup');
        if (modalPopup) {
          modalPopup.setAttribute('aria-hidden', 'false');
          buttonPopup.style.display = "none";
        }
      }
    }
  })();

  // Button Popup Link
  (function buttonPopupLink() {
    var buttonPopup = document.getElementById('button_popup--link');
    if (buttonPopup) {
      var buttonPopupClose = buttonPopup.querySelector('.button_popup--link__close');
      if (buttonPopupClose) {
        buttonPopupClose.addEventListener('click', function () {
          buttonPopup.style.display = "none";
        });
      }
      var modalPopup = document.querySelector('.modal--button_popup');
      if (modalPopup) {
        var modalPopupClose = modalPopup.querySelector('.popup-newsletter__close');
        if (modalPopupClose) {
          modalPopupClose.addEventListener('click', function () {
            modalPopup.setAttribute('aria-hidden', 'true');
          });
        }
      }
    }

    // Handle URL with customer_posted=true
    if (window.location.href.indexOf("customer_posted=true") > -1) {
      if (buttonPopup) {
        var modalPopup = document.querySelector('.modal--button_popup');
        if (modalPopup) {
          modalPopup.setAttribute('aria-hidden', 'false');
          buttonPopup.style.display = "none";
        }
      }
    }
  })();

  // Blog Notice "Leia Mais" Button
  (function blogNoticeToggle() {
    let currUrl = window.location.href;
    if (currUrl.includes("blog-page")) {
      var noticeText = document.getElementById("noticeText");
      if (noticeText) {
        var toggleButton = document.getElementById("toggleButton");
        var isExpanded = false;
        var originalText = noticeText.textContent.trim();
        var firstSentence = originalText.split('.')[0] + "...";
        if (originalText !== firstSentence) {
          noticeText.textContent = firstSentence;
        }

        if (toggleButton) {
          toggleButton.addEventListener("click", function () {
            if (!isExpanded) {
              noticeText.textContent = originalText;
              toggleButton.textContent = "Leia menos";
            } else {
              noticeText.textContent = firstSentence;
              toggleButton.textContent = "Leia mais";
            }
            isExpanded = !isExpanded;
          });
        }
      }
    }
  })();
});

/* BEGIN Bioself product-page stock/cart quantity guard. 2026-09-09. */
(() => {
  'use strict';
  if (window.BioselfProductStockGuard) return;
  const ROOT = '#product_page_custom, #product_page_custom_mobile';
  const ADD = 'button[id="add-to-cart"][data-product-id]';
  const INPUT = 'input[id="product-quantity"]';
  const PLUS = '[id="increase-quantity"]';
  const MINUS = '[id="decrease-quantity"]';
  const originalButtons = new WeakMap();
  let snapshot = null;
  let busy = false;
  let loading = false;
  let quantity = 1;
  let blank = false;
  let message = '';
  let phase = '';
  let sequence = 0;
  let timer;

  const roots = () => [...document.querySelectorAll(ROOT)];
  const controls = (selector) => roots().flatMap((root) => [...root.querySelectorAll(selector)]);
  const currentId = () => controls(ADD)[0]?.getAttribute('data-product-id') || '';

  // Quantity rules apply to the variant total, including separate cart lines.
  function limits(data) {
    const rule = data.quantity_rule || {};
    const step = Math.max(1, Number(rule.increment) || 1);
    const cart = data.cart_quantity;
    let min = Math.max(1, (Number(rule.min) || 1) - cart);
    min += (step - ((cart + min) % step)) % step;
    let totalMax = Infinity;
    if (data.inventory_management && data.inventory_policy !== 'continue') {
      totalMax = Math.max(0, data.inventory_quantity);
    }
    if (rule.max !== null && rule.max !== undefined) {
      totalMax = Math.min(totalMax, Math.max(0, Number(rule.max)));
    }
    const remaining = Math.max(0, totalMax - cart);
    const max = !data.available || remaining < min
      ? 0
      : Number.isFinite(remaining) ? min + Math.floor((remaining - min) / step) * step : Infinity;
    return { min, max, step };
  }

  function normalize(value, bounds) {
    if (!bounds.max) return 0;
    const number = Number(value);
    const whole = Number.isFinite(number) ? Math.floor(number) : bounds.min;
    return Math.min(bounds.max, bounds.min + Math.floor((Math.max(bounds.min, whole) - bounds.min) / bounds.step) * bounds.step);
  }

  function stockMessage() {
    if (!snapshot) return loading ? 'A verificar a disponibilidade...' : 'Não foi possível verificar o stock. Prima Adicionar para tentar novamente.';
    const bounds = limits(snapshot);
    if (!bounds.max) {
      return snapshot.cart_quantity > 0
        ? 'Não é possível adicionar mais unidades. A quantidade disponível ou permitida já está no carrinho.'
        : 'Não há quantidade disponível para adicionar.';
    }
    const cartText = snapshot.cart_quantity ? ` Já tem ${snapshot.cart_quantity} no carrinho.` : '';
    return Number.isFinite(bounds.max)
      ? `Pode adicionar até ${bounds.max} ${bounds.max === 1 ? 'unidade' : 'unidades'}.${cartText}`
      : cartText.trim();
  }

  function setDisabled(element, disabled) {
    element.setAttribute('aria-disabled', String(disabled));
    element.setAttribute('data-bioself-stock-disabled', String(disabled));
    if ('disabled' in element) element.disabled = disabled;
  }

  function render() {
    const bounds = snapshot ? limits(snapshot) : null;
    const locked = busy || loading;
    if (bounds && !blank) quantity = normalize(quantity, bounds);
    roots().forEach((root, index) => {
      const input = root.querySelector(INPUT);
      const button = root.querySelector(ADD);
      if (!input || !button) return;
      if (!originalButtons.has(button)) originalButtons.set(button, button.innerHTML);
      let status = root.querySelector('[data-bioself-stock-status]');
      if (!status) {
        status = document.createElement('p');
        status.setAttribute('data-bioself-stock-status', '');
        status.id = `bioself-product-stock-status-${index}`;
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.style.cssText = 'font-size:13px;line-height:1.4;margin:0;max-width:390px;';
        const anchor = root.querySelector('.quantity_stock_container');
        if (anchor) anchor.insertAdjacentElement('afterend', status);
        else button.insertAdjacentElement('afterend', status);
        const describedBy = input.getAttribute('aria-describedby') || '';
        input.setAttribute('aria-describedby', `${describedBy} ${status.id}`.trim());
      }
      status.textContent = message || stockMessage();
      status.hidden = !status.textContent;
      input.min = bounds?.max === 0 ? '0' : String(bounds?.min || 1);
      input.step = String(bounds?.step || 1);
      if (bounds && Number.isFinite(bounds.max)) input.max = String(bounds.max);
      else input.removeAttribute('max');
      input.value = blank ? '' : String(quantity);
      input.setAttribute('aria-label', 'Quantidade a adicionar ao carrinho');
      setDisabled(input, locked || bounds?.max === 0);
      setDisabled(button, locked || bounds?.max === 0 || blank);
      button.setAttribute('aria-busy', String(busy));
      if (busy) button.textContent = phase || 'A verificar...';
      else if (button.innerHTML !== originalButtons.get(button)) button.innerHTML = originalButtons.get(button);
      [[PLUS, true], [MINUS, false]].forEach(([selector, increasing]) => {
        const control = root.querySelector(selector);
        if (!control) return;
        const disabled = locked || !bounds || !bounds.max || (increasing ? quantity >= bounds.max : quantity <= bounds.min);
        control.setAttribute('role', 'button');
        control.setAttribute('aria-label', increasing ? 'Aumentar quantidade' : 'Diminuir quantidade');
        control.setAttribute('tabindex', disabled ? '-1' : '0');
        setDisabled(control, disabled);
      });
    });
  }

  async function request(url, options = {}) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), options.method === 'POST' ? 20000 : 12000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const text = await response.text();
      return { response, text };
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function refresh(force = false, id = currentId()) {
    if ((!force && busy) || !/^\d+$/.test(id)) return null;
    const version = ++sequence;
    loading = true;
    render();
    try {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', 'bioself-product-stock');
      url.searchParams.set('variant', id);
      url.searchParams.set('_bioself_stock', String(Date.now()));
      const { response, text } = await request(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Stock indisponível.');
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const node = doc.querySelector('[data-bioself-product-stock]');
      const data = node ? JSON.parse(node.textContent) : null;
      if (!data || String(data.id) !== id || typeof data.available !== 'boolean' ||
          !Number.isSafeInteger(data.cart_quantity) || data.cart_quantity < 0 ||
          (data.inventory_management && !Number.isSafeInteger(data.inventory_quantity))) {
        throw new Error('Resposta de stock inválida.');
      }
      if (version === sequence) {
        snapshot = data;
        if (Number.isSafeInteger(data.cart_item_count)) {
          document.querySelectorAll('.header__cart-count').forEach((counter) => {
            counter.textContent = data.cart_item_count;
            counter.setAttribute('aria-label', `${data.cart_item_count} artigo(s) no carrinho`);
          });
          if (window.theme) window.theme.cartCount = data.cart_item_count;
        }
      }
      return data;
    } catch (error) {
      if (version === sequence) {
        snapshot = null;
        if (!message) message = 'Não foi possível verificar o stock. Prima Adicionar para tentar novamente.';
      }
      throw error;
    } finally {
      if (version === sequence) {
        loading = false;
        render();
      }
    }
  }

  function scheduleRefresh() {
    if (busy || !controls(ADD).length) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      message = '';
      refresh().catch(() => {});
    }, 150);
  }

  function quantityAction(element, delta) {
    if (busy || loading) return;
    if (!snapshot) { scheduleRefresh(); return; }
    const bounds = limits(snapshot);
    const input = element.closest(ROOT)?.querySelector(INPUT);
    const previous = normalize(input?.value || quantity, bounds);
    quantity = normalize(previous + delta * bounds.step, bounds);
    blank = false;
    message = '';
    render();
  }

  function editQuantity(input, allowBlank) {
    if (busy || loading || !snapshot) { render(); return; }
    const value = input.value;
    blank = allowBlank && value === '';
    message = '';
    if (!blank) {
      quantity = normalize(value, limits(snapshot));
      if (Number(value) !== quantity) message = `A quantidade foi ajustada para ${quantity}.`;
    }
    render();
  }

  function notify(button, name, detail) {
    button.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  }

  async function add(button) {
    if (busy || blank) return;
    const id = button.getAttribute('data-product-id');
    const input = button.closest(ROOT)?.querySelector(INPUT);
    const requested = Number(input?.value);
    if (!/^\d+$/.test(id || '') || !input) return;
    busy = true;
    message = '';
    phase = 'A verificar...';
    let attempted = false;
    let confirmed = false;
    render();
    try {
      // Re-read both stock and cart immediately before submitting the addition.
      const data = await refresh(true, id);
      const bounds = limits(data);
      if (!button.isConnected || button.getAttribute('data-product-id') !== id) {
        message = 'O produto selecionado mudou. Confirme a quantidade antes de adicionar.';
        return;
      }
      if (!Number.isSafeInteger(requested) || requested < bounds.min || requested > bounds.max ||
          normalize(requested, bounds) !== requested) {
        quantity = normalize(requested, bounds);
        message = bounds.max === 0 ? stockMessage() : 'A quantidade foi ajustada à disponibilidade atual. Confirme antes de adicionar.';
        return;
      }
      phase = 'A adicionar...';
      render();
      const root = window.Shopify?.routes?.root || window.routes?.rootUrl || '/';
      const url = root.replace(/\/?$/, '/') + 'cart/add.js';
      attempted = true;
      const { response, text } = await request(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id, quantity: requested }),
      });
      const payload = JSON.parse(text);
      if (!response.ok || Number(payload.status) >= 400 || payload.errors) {
        const error = new Error(payload.description || payload.message || 'Não foi possível adicionar esta quantidade.');
        error.payload = payload;
        throw error;
      }
      confirmed = true;
      notify(button, 'product:added', { variant: payload, quantity: requested, button });
    } catch (error) {
      message = error.payload
        ? error.message
        : attempted ? 'Não foi possível confirmar a adição. Verifique o carrinho antes de tentar novamente.'
          : 'Não foi possível verificar o stock. Prima Adicionar para tentar novamente.';
      if (attempted) {
        notify(button, 'product:add-error', { error: error.payload || { description: message }, trigger: button });
        // An unsuccessful response may still have changed the cart; never retry automatically.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      }
    } finally {
      if (attempted) {
        try { await refresh(true); }
        catch (_) {
          if (confirmed) message = 'Produto adicionado. Não foi possível atualizar a disponibilidade; verifique o carrinho.';
        }
      }
      busy = false;
      phase = '';
      render();
    }
  }

  // Capture only the two custom product-page controls, ahead of their legacy handlers.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target?.closest(ROOT)) return;
    const button = target.closest(ADD);
    const control = target.closest(`${PLUS}, ${MINUS}`);
    if (!button && !control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button) void add(button);
    else quantityAction(control, control.matches(PLUS) ? 1 : -1);
  }, true);

  ['input', 'change', 'blur'].forEach((type) => document.addEventListener(type, (event) => {
    if (!(event.target instanceof Element) || !event.target.matches(INPUT) || !event.target.closest(ROOT)) return;
    event.stopImmediatePropagation();
    editQuantity(event.target, type === 'input');
  }, true));

  document.addEventListener('keydown', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest(ROOT)) return;
    const control = target.closest(`${PLUS}, ${MINUS}`);
    const isArrow = target.matches(INPUT) && ['ArrowUp', 'ArrowDown'].includes(event.key);
    if (!isArrow && !(control && ['Enter', ' '].includes(event.key))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    quantityAction(control || target, isArrow ? (event.key === 'ArrowUp' ? 1 : -1) : (control.matches(PLUS) ? 1 : -1));
  }, true);

  function init() {
    if (!controls(ADD).length) return;
    if (!document.getElementById('bioself-stock-guard-style')) {
      const style = document.createElement('style');
      style.id = 'bioself-stock-guard-style';
      style.textContent = '[data-bioself-stock-disabled="true"]{opacity:.5;cursor:not-allowed!important;}';
      document.head.appendChild(style);
    }
    roots().forEach((root) => {
      if (root.dataset.bioselfStockObserved) return;
      root.dataset.bioselfStockObserved = 'true';
      new MutationObserver(() => { snapshot = null; scheduleRefresh(); }).observe(root, {
        attributes: true, subtree: true, attributeFilter: ['data-product-id'],
      });
    });
    refresh().catch(() => {});
  }

  window.BioselfProductStockGuard = { refresh: scheduleRefresh };
  ['product:added', 'bioself:cart-updated', 'cart:updated', 'cart:refresh'].forEach((type) => {
    document.addEventListener(type, scheduleRefresh, true);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleRefresh(); });
  window.addEventListener('focus', scheduleRefresh);
  window.addEventListener('pageshow', scheduleRefresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END Bioself product-page stock/cart quantity guard. */

